document.addEventListener("DOMContentLoaded", function () {
  const SCREENSHOT_INTERVAL = 4000;

  const screenshotsContainer = document.querySelector(
    ".enterprise-section__screenshots"
  );
  const screenshots = document.querySelectorAll(
    ".enterprise-section__screenshot"
  );
  const logos = document.querySelectorAll(".enterprise-section__logo-item");

  if (!screenshotsContainer || screenshots.length === 0) {
    return;
  }

  const screenshotOrder = ["epic", "asana", "cloudflare", "monzo"];
  let currentIndex = 0;
  let intervalId = null;

  screenshots.forEach((screenshot) => {
    screenshot.classList.remove("is-active");
  });

  logos.forEach((logo) => {
    logo.classList.remove("is-active");
  });

  function updateActiveScreenshot() {
    const activeScreenshotName = screenshotOrder[currentIndex];

    screenshots.forEach((screenshot) => {
      screenshot.classList.remove("is-active");
    });

    logos.forEach((logo) => {
      logo.classList.remove("is-active");
    });

    const activeScreenshot = Array.from(screenshots).find(
      (screenshot) => screenshot.dataset.screenshot === activeScreenshotName
    );

    if (activeScreenshot) {
      activeScreenshot.classList.add("is-active");
    }

    const activeLogo = Array.from(logos).find(
      (logo) => logo.dataset.logo === activeScreenshotName
    );

    if (activeLogo) {
      activeLogo.classList.add("is-active");
    }
  }

  function startInterval() {
    if (intervalId) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(() => {
      currentIndex = (currentIndex + 1) % screenshotOrder.length;
      updateActiveScreenshot();
    }, SCREENSHOT_INTERVAL);
  }

  updateActiveScreenshot();
  startInterval();

  screenshotsContainer.addEventListener("mouseenter", () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  });

  screenshotsContainer.addEventListener("mouseleave", () => {
    startInterval();
  });

  logos.forEach((logo) => {
    logo.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const logoName = this.dataset.logo;
      if (logoName) {
        const newIndex = screenshotOrder.indexOf(logoName);
        if (newIndex !== -1) {
          currentIndex = newIndex;
          updateActiveScreenshot();
          startInterval();
        }
      }
    });
  });
});
